import React, { PureComponent } from 'react'
import { connect } from 'react-redux'

import generalActions from 'redux/actions/generalActions'
import matchingPairsCreationToolActions from 'redux/actions/matching_pairs_ct_actions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'
import containerSelector from 'redux/selectors/matching_pairs/creation_tool_pair_editor_selector'

import PairEditorModal from 'views/slides/activities/matching_pairs/creation_tool/modals/pair_editor/pair_editor_modal'

class PairEditorModalContainer extends PureComponent {

	constructor() {
		super()
		this.closeModalHandler = this.closeModalHandler.bind(this)
		this.deletePairHandler = this.deletePairHandler.bind(this)
		this.discardContent = this.discardContent.bind(this)
	}

	closeModalHandler() {
		this.props.actions.closeModal(this.props.modalName)
		if (!!this.props.id) {
			this.props.actions.closeEditPair()
		}
	}

	deletePairHandler() {
		this.props.actions.deletePair(this.props.id)
	}

	discardContent(cardName) {
		this.props.actions.discardContent(cardName, this.props.clientId)
	}

	render() {
		return (
			<PairEditorModal
				id={this.props.id}
				clientId={this.props.clientId}
				title={this.props.title}
				card1={this.props.card1}
				card2={this.props.card2}
				closeModalHandler={this.closeModalHandler}
				imageLoadHandler={this.props.actions.imageLoad}
				changeImageMatrixHandler={this.props.actions.changeImageMatrix}
				changeTextHandler={this.props.actions.changeText}
				discardContentHandler={this.discardContent}
				addAnImageHandler={this.props.actions.addAnImage}
				newTextHandler={this.props.actions.newText}
				pairSaveHandler={this.props.actions.pairSave}
				pairStatus={this.props.pairStatus}
				pairAddAnotherHandler={this.props.actions.pairAddAnother}
				showAddAnotherPair={this.props.showAddAnotherPair}
				deletePairHandler={this.deletePairHandler}
				isNewPair={this.props.isNewPair}
				canSave={this.props.canSave}
			/>
		)
	}

}

function mapStateToProps(state) {
	return containerSelector(state)
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		changeText: matchingPairsCreationToolActions.pairChangeText,
		discardContent: matchingPairsCreationToolActions.pairDiscardContent,
		addAnImage: matchingPairsCreationToolActions.pairAddAnImage,
		newText: matchingPairsCreationToolActions.cardNewText,
		closeModal: generalActions.closeModal,
		pairSave: matchingPairsCreationToolActions.pairSave,
		pairAddAnother: matchingPairsCreationToolActions.pairAddAnother,
		deletePair: matchingPairsCreationToolActions.deletePair,
		closeEditPair: matchingPairsCreationToolActions.closeEditPair,
		changeImageMatrix: matchingPairsCreationToolActions.pairChangeImageMatrix,
		imageLoad: matchingPairsCreationToolActions.pairImageLoad,
	}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PairEditorModalContainer)
